import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { Header, AddButton } from '../../components';
import { validateAccess } from '../../session';
import { pollsLoaded, setAuth } from '../../actions';
import { feedbackActions } from '../../webapi';
import { COLOUR_BRANDING_OFF } from '../../js';
import Polls from './Polls';

class PollsHub extends Component {
  state = {
    selectedSection: 'current',
    location: '',

    loadingPolls: false,

    polls: [],
    currentPolls: [],
    pastPolls: [],
    now: moment.utc().valueOf(),
  };

  UNSAFE_componentWillMount() {
    this.updateProps(this.props);

    this.loadPolls();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    const polls = [];

    props.polls.forEach((ev) => {
      if (ev != null && !ev.Deleted) {
        polls.push(ev);
      }
    });

    const currentPolls = _.filter(polls, (ev) => {
      return this.state.now > ev.StartTime && this.state.now < ev.EndTime;
    });

    const pastPolls = _.filter(polls, (ev) => {
      return this.state.now > ev.EndTime;
    });

    this.setState({ polls, currentPolls, pastPolls });
  }

  loadPolls() {
    this.setState({
      loadingPolls: true,
    });

    feedbackActions
      .getPolls(this.props.auth.site)
      .then((res) => {
        this.setState({
          loadingPolls: false,
        });
        if (res.data != null && !_.isEmpty(res.data) && res.data[0].Site === this.props.auth.site) {
          this.props.pollsLoaded(res.data);
        }
      })
      .catch((res) => {
        this.setState({ loadingPolls: false });
        alert('Something went wrong with the request. Please try again.');
      });
  }

  addNew() {
    if (this.canAddNew()) {
      this.props.history.push(`/polls/poll`);
    }
  }

  canAddNew(isClass) {
    if (validateAccess(this.props.auth.site, 'polls', this.props.auth)) {
      return isClass ? '' : true;
    }
    return isClass ? ' hub-sideContent-topButton--hide' : false;
  }

  getSideBarSectionColour(id) {
    return this.state.selectedSection === id ? { backgroundColor: '#fff' } : {};
  }

  renderStats(component, loading) {
    if (loading) {
      return <FontAwesome style={styles.spinner} name="spinner fa-pulse fa-fw" />;
    }
    return component;
  }

  renderLeftBar() {
    return (
      <div className="hub-sideContent">
        {/* Top Add Button */}
        <div className="hub-sideContent-topButton" />
        <div style={{ paddingLeft: 15, width: '100%' }}>
          {/* Title */}
          <div className="fontMedium fontSize-36 text-dark" style={styles.sideBarTitleSection}>
            Surveys
          </div>
          {/* Content */}
          {/* All Polls */}
          <div
            onClick={() => {
              this.setState({ selectedSection: 'all' });
            }}
            className="sideBarSection"
            style={this.getSideBarSectionColour('all')}
          >
            <div className="fontMedium fontSize-36 text-dark" style={{ lineHeight: '50px' }}>
              {this.renderStats(this.state.polls.length, this.state.loadingPolls)}
            </div>
            <div className="fontRegular fontSize-16 text-light lineHeight-22">All Surveys</div>
          </div>
          {/* current Polls */}
          <div
            onClick={() => {
              this.setState({ selectedSection: 'current' });
            }}
            className="sideBarSection"
            style={this.getSideBarSectionColour('current')}
          >
            <div className="fontMedium fontSize-36 text-dark" style={{ lineHeight: '50px' }}>
              {this.renderStats(this.state.currentPolls.length, this.state.loadingPolls)}
            </div>
            <div className="fontRegular fontSize-16 text-light lineHeight-22">Current Surveys</div>
          </div>
          {/* Past Polls */}
          <div
            onClick={() => {
              this.setState({ selectedSection: 'past' });
            }}
            className="sideBarSection"
            style={this.getSideBarSectionColour('past')}
          >
            <div className="fontMedium fontSize-36 text-dark" style={{ lineHeight: '50px' }}>
              {this.renderStats(this.state.pastPolls.length, this.state.loadingPolls)}
            </div>
            <div className="fontRegular fontSize-16 text-light lineHeight-22">Past Surveys</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="hub-wrapperContainer">
        {this.renderLeftBar()}
        <div className="hub-headerContentWrapper">
          <Header>{this.canAddNew() && <AddButton onClick={this.addNew.bind(this)} text="NEW SURVEY" />}</Header>
          <div className="hub-contentWrapper">
            <Polls filterOption={this.state.selectedSection} />
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  sideBarTitleSection: {
    lineHeight: '50px',
    marginTop: 30,
    marginBottom: 30,
    paddingLeft: 24,
  },
  sideBarSection: {
    weight: '100%',
    minWidth: 200,
    padding: 32,
    paddingLeft: 24,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  spinner: {
    fontSize: 32,
    color: COLOUR_BRANDING_OFF,
  },
};

const mapStateToProps = (state) => {
  const { polls } = state.feedback;
  const { auth } = state;
  return {
    polls,
    auth,
  };
};

export default connect(mapStateToProps, { pollsLoaded, setAuth })(PollsHub);
